import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { PeopleSimilaritySearch } from '@aibees/elephant/feature';
import * as Styled from './styles';
import * as SX from './sx';
import type { HomePeopleSearchProps as Props } from './types';

export const HomePeopleSearch = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('HomePeopleSearch', className)}
      sx={SX.root}
    >
      <PeopleSimilaritySearch renderMode="dialog" />
    </Styled.Wrapper>
  );
});

HomePeopleSearch.displayName = 'HomePeopleSearch';
